import { FREE_SHIPPING } from 'src/constants/meta';

export const helmet = {
    title: 'Personalised Work Clothing & Work Uniforms | Workwear Express',
    description: `Your Company Logo On 2 Million+ Items ✓ 24 Hour Dispatch ✓ Free Delivery Over ${FREE_SHIPPING} ✓ Free Returns ✓ 600000 Happy Customers`,
};
